import { useMutation } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export function useGetAllCerts() {
  return useMutation({
    mutationFn: ({
      page,
      limit,
      search,
      isActive,
      showDBS,
      isComplianceCertificate,
    }) => {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
      });

      if (search) {
        params.append("search", search);
      }
      if (isActive != null && isActive !== "") {
        params.append("isActive", String(isActive));
      }
      if (showDBS != null && showDBS !== "") {
        params.append("showDBS", String(showDBS));
      }
      if (
        isComplianceCertificate != null &&
        isComplianceCertificate !== ""
      ) {
        params.append(
          "isComplianceCertificate",
          String(isComplianceCertificate)
        );
      }

      return apiClient({
        url: `admin/certs/all?${params.toString()}`,
        method: "GET",
      });
    },
  });
}

/** Active courses for certificate create/update (single `courseSlug`; list items include `courseId`). */
export function useGetAdminCourses() {
  return useMutation({
    mutationFn: ({ page = 1, limit = 50, isActive = true, ...params } = {}) =>
      apiClient({
        url: "admin/courses/all",
        method: "GET",
        params: { page, limit, isActive, ...params },
      }),
  });
}

export function useCreateCert() {
  return useMutation({
    mutationFn: (payload) => {
      return apiClient({
        url: "admin/create-certs",
        method: "POST",
        data: payload,
      });
    },
  });
}

export function useUpdateCert() {
  return useMutation({
    mutationFn: ({ slug, payload }) => {
      return apiClient({
        url: `admin/update-certs/${slug}`,
        method: "PATCH",
        data: payload,
      });
    },
  });
}

export function useToggleCertStatus() {
  return useMutation({
    mutationFn: ({ slug, status }) => {
      return apiClient({
        url: `admin/activate-deactivate-certs/${slug}`,
        method: "PATCH",
        data: { status },
      });
    },
  });
}

export function useGetAllCertsNotPaginated() {
  return useMutation({
    mutationFn: (params = {}) => {
      return apiClient({
        url: `certs/all`,
        method: "GET",
        params,
      });
    },
  });
}

export function useGetActiveCerts() {
  return useMutation({
    mutationFn: ({ isActive = true, ...params }) => {
      return apiClient({
        url: `admin/certs/all`,
        method: "GET",
        params: { isActive, ...params },
      });
    },
  });
}
